import { supabase } from '../../core/config/supabase';
import { TournamentAdmin } from '../../domain/models';
import { TournamentAdminRepository } from '../../domain/repositories';
import { TournamentAdminDataSource } from '../datasources/TournamentAdminDataSource';
import { tournamentAdminEntityToModel, tournamentAdminModelToEntity } from '../entities';
import { logger } from '@/src/core/utils';

export class TournamentAdminRepositoryImpl implements TournamentAdminRepository {
    constructor(private dataSource: TournamentAdminDataSource) { }

    async create(admin: Omit<TournamentAdmin, 'id' | 'createdAt' | 'userEmail' | 'userName'>): Promise<TournamentAdmin> {
        const entity = tournamentAdminModelToEntity(admin);
        const createdEntity = await this.dataSource.create(entity as any);

        // Get user info usando RPC
        try {
            const { data } = await supabase.rpc('search_user_by_email_by_id', {
                user_id: admin.userId
            });

            if (data && data.length > 0) {
                const user = data[0];
                return tournamentAdminEntityToModel(
                    createdEntity,
                    user.email,
                    user.raw_user_meta_data?.full_name
                );
            }
        } catch (err) {
            logger.error('TournamentAdminRepo', 'Error fetching user info', { error: err });
        }

        // Fallback sin info de usuario
        return tournamentAdminEntityToModel(createdEntity);
    }

    async getByTournamentId(tournamentId: string): Promise<TournamentAdmin[]> {
        const entities = await this.dataSource.getByTournamentId(tournamentId);

        // Get user info for all admins usando la función RPC
        const adminsWithUserInfo = await Promise.all(
            entities.map(async (entity) => {
                try {
                    const { data, error } = await supabase.rpc('search_user_by_email_by_id', {
                        user_id: entity.user_id
                    });

                    if (!error && data && data.length > 0) {
                        const user = data[0];
                        return tournamentAdminEntityToModel(
                            entity,
                            user.email,
                            user.raw_user_meta_data?.full_name
                        );
                    }
                } catch (err) {
                    logger.error('TournamentAdminRepo', 'Error fetching user info', { error: err });
                }

                // Fallback sin info de usuario
                return tournamentAdminEntityToModel(entity);
            })
        );

        return adminsWithUserInfo;
    }

    async delete(id: string): Promise<void> {
        await this.dataSource.delete(id);
    }

    async deleteByUserAndTournament(userId: string, tournamentId: string): Promise<void> {
        await this.dataSource.deleteByUserAndTournament(userId, tournamentId);
    }
}